import { PropsWithChildren } from 'react';
import { Grid } from '../../../layout';
import { IGridProps } from '../../../layout/Grid';

type ITabListProps = IGridProps;

export function TabList({
  children,
  ...rest
}: PropsWithChildren<ITabListProps>) {
  return <Grid {...rest}>{children}</Grid>;
}
